import type { CustomField } from "./schemas";

export function customFieldOptions(
  field: Pick<CustomField, "type" | "options">,
): { id: string; label: string; color?: string }[] {
  const raw: unknown = field.options;
  const rows = Array.isArray(raw)
    ? raw
    : field.type === "SPRINT" &&
        raw &&
        typeof raw === "object" &&
        "sprints" in raw &&
        Array.isArray(raw.sprints)
      ? raw.sprints
      : [];
  return rows.flatMap((row) => {
    if (!row || typeof row !== "object" || typeof row.id !== "string")
      return [];
    const label =
      typeof row.label === "string"
        ? row.label
        : typeof row.name === "string"
          ? row.name
          : "";
    return label
      ? [
          {
            id: row.id,
            label,
            ...(typeof row.color === "string" ? { color: row.color } : {}),
          },
        ]
      : [];
  });
}
